import React from 'react'
import ReactDOM from 'react-dom'
import {Provider} from 'react-redux'

import ConfigureStore from './store/ConfigureStore.js'
import Api from './modules/Api.js'
import {
  updateAll,
  updatePlaylists,
  updateTracks,
  updateBackground,
  updateObjects,
  setAutoplay
} from './actions/Actions.js'

import Interface from './components/interface/containers/Interface.js'
import Radio from './components/radio/containers/Radio.js'
import Background from './components/background/Background.jsx'
import Page from './components/page/containers/Page.js'

const store = ConfigureStore()

function render () {
  const storeState = store.getState()
  // console.dir(storeState)
  ReactDOM.render(
    <Provider store={store}>
      <div>
        <Interface className="interface" />
        <Radio className="radio"
          big={false}
          mini={true}
          autoplay={storeState.radio.autoplay}
          store={store} />
        <Background className="map"
          minZoomLevel={1.0}
          maxZoomLevel={7.5}
          defaultZoomLevel= {4.5} // {7.5}
          zoomPerScroll={0.1} />
        <Page className="page" />
      </div>
    </Provider>,
    document.getElementsByTagName('main')[0]
  )
}

// function hideLoader () {
//   const loader = document.getElementById('loader')
//   loader.classList.add('loaded')
//   setTimeout(() => {
//     loader.remove()
//   }, 400)
// }

const apiCall = new Api()

const promises = [
  apiCall.getPage('meta'),
  apiCall.getPage('playlists'),
  apiCall.getPage('background'),
  apiCall.getPage('objects'),
  apiCall.getPage('radio')
]
Promise.all(promises)
  .then(data => {
    let i = 0
    const obj = {
      meta: data[i] ? data[i++].response : null,
      playlists: data[i] ? data[i++].response : null,
      bg: data[i] ? data[i++].response : null,
      overlays: data[i] ? data[i++].response : null,
      radio: data[i] ? data[i++].response : null
    }
    if (obj.playlists && obj.playlists.constructor === Array && obj.playlists.length) {
      apiCall.getPage('tracks', obj.playlists[0].uid)
        .then(tracksdata => {
          store.dispatch(updateTracks(tracksdata.response))
        })
        .catch(error => {
          console.error(error)
        })
    }
    store.dispatch(updateBackground(obj))
    store.dispatch(updateObjects(obj.overlays))
    store.dispatch(updatePlaylists(obj.playlists))
    store.dispatch(updateAll(obj))
    store.dispatch(setAutoplay(obj && obj.radio ? obj.radio.autoplay : undefined))
    console.dir(obj)
  })
  .then(() => {
    store.subscribe(render)
    // setTimeout(() => {
    // hideLoader()
    // }, 20)
  })
  .catch(error => {
    console.error(error)
  })
